// src/components/Dashboard/OperationEfficiencyChart.js
import React from 'react';
import { Paper, Typography } from '@mui/material';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Label } from 'recharts';

const OperationEfficiencyChart = ({ data }) => {
    // 自訂 Tooltip formatter
    const customTooltipFormatter = (value, name) => {
        switch (name) {
            case "總里程":
                return [`${value} km`, name];
            case "總燃料消耗":
                return [`${value} L`, name];
            case "總燃料費用":
                return [`${value} 元`, name];
            case "總碳排放":
                return [`${value} g CO₂`, name];
            default:
                return [value, name];
        }
    };
    return (
        <Paper elevation={3} sx={{ p: 2, borderRadius: '10px', backgroundColor: 'white' }}>
            <Typography variant="subtitle1" gutterBottom>運營效率的碳排放指標</Typography>
            <ResponsiveContainer width="100%" height={300}>
                <LineChart
                    data={data}
                    margin={{ top: 5, right: 70, left: 40, bottom: 30 }} // 調整邊距以容納標籤
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis
                        dataKey="month"
                        tickFormatter={(value) => `${value}月`}
                    >
                        <Label value="月份" position="bottom" offset={5} />
                    </XAxis>
                    <YAxis yAxisId="left">
                        <Label value="里程(Km)/燃料(L)/費用(元)" angle={-90} offset={-30} position="insideLeft" style={{ textAnchor: 'middle' }} />
                    </YAxis>
                    <YAxis yAxisId="right" orientation="right">
                        <Label
                            value="碳排放量 (g CO₂)"
                            angle={90}
                            position="insideRight"
                            offset={-60}  // 添加負值 offset 使標籤向右移動
                            style={{ textAnchor: 'middle' }}
                        />
                    </YAxis>
                    <Tooltip formatter={customTooltipFormatter} labelFormatter={(label) => `${label}月`} />
                    <Legend
                        verticalAlign="bottom"
                        height={20}
                        wrapperStyle={{
                            paddingTop: '10px',
                            bottom: 10
                        }}
                    />
                    <Line yAxisId="left" type="monotone" dataKey="totalMileage" name="總里程" stroke="#8884d8" />
                    <Line yAxisId="left" type="monotone" dataKey="totalFuelConsumed" name="總燃料消耗" stroke="#82ca9d" />
                    <Line yAxisId="left" type="monotone" dataKey="totalFuelExpense" name="總燃料費用" stroke="#ffc658" />
                    <Line yAxisId="right" type="monotone" dataKey="totalCarbonEmission" name="總碳排放" stroke="#ff7300" />
                </LineChart>
            </ResponsiveContainer>
        </Paper>);
};
export default OperationEfficiencyChart;